module.exports = {"shipping_rates":[{"type":"Standaard","description":"0 – 10 kg","price":7.45,"dimensions":"100 x 50 x 50 cm"},{"type":"Standaard","description":"10 – 23 kg","price":17.45,"dimensions":"176 x 78 x 58 cm"},{"type":"Aangetekend","description":"0 – 10 kg","price":11.25,"dimensions":"100 x 50 x 50 cm"},{"type":"Aangetekend","description":"10 – 30 kg","price":21.25,"dimensions":"176 x 78 x 58 cm"}],"special_rate":{"type":"Free","description":"Above €99,95","price":99.95,"dimensions":"N/A"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/shippingRates.json
// module id = 72
// module chunks = 0